import { FamilySharingPermission } from '~/features/Profile/types'
import type {
  FamilySharingScopeDto,
  ScopesAccess,
  FamilySharingSettingsDto,
  FamilySharingSettings,
  FamilySharingDto,
  FamilySharing,
} from '~/features/Profile/types'

const mapScopes = <Scope extends string>(items: FamilySharingScopeDto<Scope>[]) => {
  const result: ScopesAccess<Scope> = {}

  items.forEach((item) => {
    if (!result[item.scope]) {
      result[item.scope] = { canRead: false, canWrite: false }
    }

    const access = result[item.scope]!

    if (item.permissions === FamilySharingPermission.Read) {
      access.canRead = true
    }

    if (item.permissions === FamilySharingPermission.Write) {
      access.canWrite = true
    }
  })

  return result
}

const mapSettings = (settings: FamilySharingSettingsDto | null): FamilySharingSettings | null => {
  if (!settings) {
    return null
  }

  return {
    appointments: mapScopes(settings.appointments),
    medcard: mapScopes(settings.medcard),
  }
}

export const mapFamilySharing = (dto: FamilySharingDto[]): FamilySharing[] => {
  return dto.map(({ uuid, status, relatedUser, me }) => ({
    uuid,
    status,
    relatedUser: {
      ...relatedUser,
      kidsUuids: relatedUser.settings?.kids.map(({ uuid: kidUuid }) => kidUuid) ?? [],
      settings: mapSettings(relatedUser.settings),
    },
    mySettings: mapSettings(me.settings),
  }))
}
